function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "play_circle_filled_white_24px"
}, /*#__PURE__*/React.createElement("path", {
  id: "icon/av/play_circle_filled_white_24px",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32.5 5.16666C17.55 5.16666 5.41669 16.74 5.41669 31C5.41669 45.26 17.55 56.8333 32.5 56.8333C47.45 56.8333 59.5834 45.26 59.5834 31C59.5834 16.74 47.45 5.16666 32.5 5.16666ZM32.5 51.6667C20.5563 51.6667 10.8334 42.3925 10.8334 31C10.8334 19.6075 20.5563 10.3333 32.5 10.3333C44.4438 10.3333 54.1667 19.6075 54.1667 31C54.1667 42.3925 44.4438 51.6667 32.5 51.6667ZM43.3334 31L27.0834 42.625V19.375L43.3334 31Z",
  fill: "white"
}));

var SvgPlayCircle = function SvgPlayCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 62,
    viewBox: "0 0 65 62",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlayCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/play_circle.308487c9.svg";
export { ForwardRef as ReactComponent };